import { AxiosRequestConfig } from 'axios';

import { loginRequest, msalInstance } from '@auth/msalConfig';
import { apiKey } from '@config/api';
import { getCurrentSearchCountry, getCurrentSearchLang } from '@models/CountriesAndLanguages';
import { store } from '@store/index';
import { getAtsTokenFromSessionStorage } from '@utils/atsSubscriberUtils';

export const baseRequestTransformer = (request: AxiosRequestConfig | RequestInit) => {
  const disableCache = store.getState().globalVars.disableCache;

  return {
    ...request,
    headers: {
      country: getCurrentSearchCountry(),
      'accept-language': getCurrentSearchLang(),
      ...request.headers,
      'content-type': 'application/json',
      'ocp-apim-subscription-key': apiKey,
      'ocp-apim-trace': 'true',
      ...(disableCache ? { 'cache-control': 'no-cache', expires: '0', pragma: 'no-cache' } : {}),
    },
  };
};

export const transformSubscriberRequest = async (request: AxiosRequestConfig | RequestInit) => {
  if (request?.headers && 'Authorization' in request.headers)
    return baseRequestTransformer(request);

  try {
    const atsToken = getAtsTokenFromSessionStorage();
    if (!atsToken) throw new Error('Token not found');

    return baseRequestTransformer({
      ...request,
      headers: { ...request.headers, Authorization: `AtsToken ${atsToken}` },
    });
  } catch (err) {
    console.error(err);
  }
};

export const transformAdminRequest = async (request: AxiosRequestConfig | RequestInit) => {
  if (request?.headers && 'Authorization' in request.headers)
    return baseRequestTransformer(request);

  const account =
    msalInstance.getAllAccounts()[0] ??
    msalInstance.handleRedirectPromise().then(res => {
      if (res) {
        msalInstance.setActiveAccount(res.account);
        return res.account;
      }
    });

  const tokenResponse = await msalInstance.acquireTokenSilent({ ...loginRequest, account });

  return baseRequestTransformer({
    ...request,
    headers: { ...request.headers, Authorization: `Bearer ${tokenResponse.accessToken}` },
  });
};
